import { Provider } from "react-redux"
import { BrowserRouter } from "react-router-dom";
import store from './redux/store/index';
import Routes from "./routes";
import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';
import Container from "./components/container";
import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { fab } from '@fortawesome/free-brands-svg-icons'
const baseUrl = '/'
library.add(fas as any, fab as any)
function App() {
  return (
    <Provider store={store}>
      <BrowserRouter basename={baseUrl} >
        <Container>
          <Routes ></Routes>
        </Container>
      </BrowserRouter>
    </Provider>
  );
}

export default App;
